<template>
  <div class="main-wrap">
    <div v-if="isShowLeftNav" class="main-left-wrap">
      <LeftNav></LeftNav>
    </div>
    <div class="main-content-wrap">
      <component :is="dom[bundleComponent(styeCode)]"> </component>
    </div>
  </div>
</template>
<script setup>
// #region 引用
import { ColumnType, OwPageType } from '@/configs/enums/website';
import useSSRInitialStateStore from '@/stores/ssr-state';
import { useSSRContext } from '@/ssr/use-context';
import singleOne from './SingleOne.vue';
import LeftNav from '../components/LeftNav.vue';
// #endregion

// #region props/emit

// #endregion

// #region 变量/常量
const styeCode = ref('ARTICLE_LIST_1');
const configInfo = ref({}); // 配置信息
const configPageList = ref(); // 配置页面列表
const columnInfo = ref();
const isShowLeftNav = ref(false);

/**
 * 动态渲染组件
 */
const dom = shallowReactive({
  singleOne,
});

// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

/**
 * 获取栏目内容缓存内容
 * SSR 期间同步读取数据（父组件 onServerPrefetch 已设置）
 * 客户端数据恢复必须在 useHead 之前，否则会覆盖 SSR 标题
 */
if (import.meta.env.SSR) {
  const ssrContext = useSSRContext();
  configInfo.value = ssrContext.initialState?.data?.current?.configInfo;
  configPageList.value = ssrContext.initialState?.data?.current?.configPageList;
  columnInfo.value = ssrContext.initialState?.data?.current?.columnInfo;
  isShowLeftNav.value =
    ssrContext.initialState?.data?.current?.topNavComponent?.isShowLeftNav;
} else {
  // 客户端：先恢复数据，再调用 useHead
  const ssrInitialState = useSSRInitialStateStore();
  columnInfo.value = ssrInitialState.data.current.columnInfo;
  configPageList.value = ssrInitialState.data.current.configPageList;
  isShowLeftNav.value =
    ssrInitialState.data.current.topNavComponent.isShowLeftNav;
  configInfo.value = ssrInitialState.data.current.configInfo;
}

// 设置页面样式代码
switch (columnInfo.value?.columnType) {
  case ColumnType.单页面栏目:
    styeCode.value = configPageList.value?.find(
      (f) => f.pageType === OwPageType.单页面,
    )?.owPageStyleCode;
    break;
  default:
    styeCode.value = configPageList.value?.find(
      (f) => f.pageType === OwPageType.单页面,
    )?.owPageStyleCode;
    break;
}

// SEO - 在 setup顶层使用computed。数据更新后自动响应
// 注意：必须在数据恢复之后调用，否则会用空值覆盖 SSR 标题
useHead({
  title: computed(
    () =>
      columnInfo.value?.columnName
        ? `${columnInfo.value.columnName} - ${configInfo.value?.homeTitle || ''}`
        : '',
  ),
  meta: [
    {
      name: 'keywords',
      content: computed(() => columnInfo.value?.columnName || ''),
    },
    {
      name: 'description',
      content: computed(() => columnInfo.value?.digest || ''),
    },
  ],
});

/**
 * 绑定组件
 * @param {*} stye 页面模板样式
 */
const bundleComponent = (stye) => {
  let component = '';
  switch (stye) {
    case 'SINGLE_1':
      component = 'singleOne';
      break;
    default:
      component = 'singleOne';
      break;
  }
  return component;
};

// #endregion
</script>

<style scoped lang="scss">
@media screen and (device-width > 1180px) {
  .main-wrap {
    display: flex;
    justify-content: center;
    max-width: 1400px;
    padding-top: 15px;
    margin: 0 auto;
  }
  .main-left-wrap {
    flex: 0 0 auto;
    width: 200px;
    margin-right: 20px;
  }
  .main-content-wrap {
    flex: 1;
  }
}
</style>

<style scoped lang="scss">
@media screen and (device-width <= 1180px) {
  .main-wrap {
    display: flex;
    justify-content: center;
  }
  .main-left-wrap {
    display: none;
  }
  .main-content-wrap {
    flex: 1;
  }
}
</style>
